import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { BaseModalModule } from '../base-modal.module';
import { StudentReportModalComponent } from './student-report.component';

@NgModule({
  declarations: [StudentReportModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatMenuModule,
    MatOptionModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatSelectModule,
    MatButtonModule,
    MatInputModule,
    MatDialogModule,
    BaseModalModule,
  ],
  exports: [StudentReportModalComponent],
  providers: [],
  entryComponents: [StudentReportModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StudentReportModalModule {}
